import * as React from "react";
import {Header, Modal} from "semantic-ui-react";
import {TransportOrderSearch} from "../../transportOrders/TransportOrderSearch";
import {useHistory, useLocation, useRouteMatch} from "react-router-dom";
import {TransportOrderView} from "../../transportOrders/TransportOrderView";
import {Splitter} from "../../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import AceEditor from "react-ace";

export interface TransportOrderSelectorProps {
    isOpen: boolean
    onClose: () => void
    transportOrderIds: string[]
    setTransportOrderIds: (transportOrderIds: string[]) => void
    allowMultipleSelection?: boolean
}

export function TransportOrderSelector(props: React.PropsWithChildren<TransportOrderSelectorProps>) {

    const [selectedTransportOrderStr, setSelectedTransportOrderStr] = React.useState(null)

    return <Modal
        id='ZohoConfirmModal'
        open={props.isOpen}
        onClose={props.onClose}
        size='fullscreen'
        closeIcon
    >
        <Header icon='list' content='Add TransportOrders'/>
        <Modal.Content>
            <Splitter
                name={"AiScripterTransportOrderSelectionModal"}
                left={<TransportOrderSearch
                    selectedOrderIdsChanged={(newSelectedOrderIds) => {props.setTransportOrderIds(newSelectedOrderIds)}}
                    selectedOrderChanged={(newSelectedOrder) => {
                        setSelectedTransportOrderStr(JSON.stringify(newSelectedOrder, null, 4))
                    }}
                    foundTransportOrdersChanged={(newFoundOrders) => {}}
                    reload={(page, take) => {}}
                    history={useHistory()}
                    initialPageSize={25}
                    hideArchiveButton={true}
                    location={useLocation()}
                    match={useRouteMatch()}
                    preSelectedTransportOrderIds={props.transportOrderIds}
                    allowMultipleSelection={props.allowMultipleSelection}
                />}
                right={
                <AceEditor
                    mode="json"
                    theme="monokai"
                    name="transportOrderSelectionEditor"
                    editorProps={{$blockScrolling: true}}
                    value={selectedTransportOrderStr}
                    width={"100%"}
                    height={"100%"}
                    readOnly={true}
                    />
                }
            />


        </Modal.Content>
    </Modal>


}